// extracted by css-extract-rspack-plugin
export default {"contentBlock":"contentBlock-F5Emhm"};